import { PageHero } from "../components/ui";
import { ADDRESS } from "../data/site";

const CONTENT = {
    privacy: {
        title: "Privacy Policy",
        eyebrow: "Legal",
        sections: [
            ["Who we are", "AddiGen Holdings Limited ('AddiGen') is the controller of personal data submitted through this website. Registered office: " + ADDRESS.lines.slice(1).join(", ") + "."],
            ["What we collect", "When you submit an enquiry, media request or job application, we collect the details you provide: name, contact details, organisation, message and, for applications, your CV."],
            ["Why we process it", "We process this data solely to respond to your enquiry or assess your application. Processing is based on your consent, given when you submit the relevant form."],
            ["GDPR consent", "By ticking the consent box on a form, you agree that AddiGen may store and process your details for the stated purpose. You may withdraw consent or request deletion at any time by contacting us."],
            ["Retention & sharing", "Data is retained only as long as necessary for the stated purpose and is not sold or shared with third parties for marketing. Access is limited to AddiGen personnel handling your enquiry or application."],
            ["Updates", "This policy is kept under review. Material updates will be published on this page."],
        ],
    },
    cookies: {
        title: "Cookie Policy",
        eyebrow: "Legal",
        sections: [
            ["What we use", "This website uses only essential functionality required to serve the site, plus standard platform analytics and web fonts loaded from third-party providers."],
            ["No advertising trackers", "AddiGen does not run advertising cookies or sell behavioural data."],
            ["Your choices", "You can control or delete cookies through your browser settings. The site remains fully navigable with cookies restricted."],
        ],
    },
    terms: {
        title: "Terms of Use",
        eyebrow: "Legal",
        sections: [
            ["Use of this website", "This website is provided for information about AddiGen and its development projects. It does not constitute an offer, a solicitation, or investment advice."],
            ["Project information", "All project descriptions and capacity figures are targets and remain subject to final investment decision. Development status can change without notice."],
            ["Intellectual property", "The AddiGen name, mark and website content are the property of AddiGen Holdings Limited and may not be reproduced without permission."],
            ["Liability", "Content is provided in good faith without warranty. AddiGen accepts no liability for decisions taken based on website content."],
            ["Governing law", "These terms are governed by the laws of Jersey."],
        ],
    },
};

export default function Legal({ kind }) {
    const c = CONTENT[kind] || CONTENT.terms;
    return (
        <>
            <PageHero eyebrow={`${c.eyebrow} — ${c.title}`} lines={[c.title + "."]} trail={[{ label: "Home", path: "/" }, { label: c.title }]} />
            <section className="bg-paper">
                <div className="container-x py-20 sm:py-24 lg:py-28">
                    <div className="max-w-3xl space-y-12">
                        {c.sections.map(([h, b], i) => (
                            <div key={h} className="border-t border-line pt-8">
                                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-blue">0{i + 1}</p>
                                <h2 className="h3-compact mt-3">{h}</h2>
                                <p className="body-lg mt-4">{b}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}
